export const MIN_PRICE_DIFF_TO_SHOW_ARROW = 10;
export const MULTI_ROOM_INITIAL_FETCH = 4;
export const COMBINED_OFFERS = ['Z+W', '7+7'];
export const MAX_RATING = 5;
